import type { AppMeta } from "@calcom/types/App";

import _package from "./package.json";

export const metadata = {
  name: "Schedly Video",
  description: _package.description,
  installed: !!process.env.DAILY_API_KEY,
  type: "daily_video",
  variant: "conferencing",
  url: "https://schedly.io",
  categories: ["conferencing"],
  logo: "icon.svg",
  publisher: "Schedly",
  category: "conferencing",
  slug: "daily-video",
  title: "Schedly Video",
  isGlobal: true,
  email: "support@schedly.io",
  appData: {
    location: {
      linkType: "dynamic",
      type: "integrations:daily",
      label: "Schedly Video",
    },
  },
  key: { apikey: process.env.DAILY_API_KEY },
  dirName: "dailyvideo",
  isOAuth: false,
} as AppMeta;

export default metadata;
